import React from 'react';
import PropTypes from 'prop-types';
import { FiExternalLink, FiCpu, FiClock, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';

const url = `${process.env.REACT_APP_API_URL}/sidekiq`;

const InfoRow = ({ icon: Icon, label, value }) => (
  <div className="tw-flex tw-items-center tw-justify-between tw-py-2.5 tw-border-b tw-border-slate-100 last:tw-border-0">
    <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-500">
      <Icon size={14} className="tw-text-slate-400" />
      {label}
    </div>
    <span className="tw-text-sm tw-font-semibold tw-text-slate-700">{value}</span>
  </div>
);
InfoRow.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

const BackgroundJobPage = () => (
  <div className="tw-max-w-lg tw-mx-auto tw-mt-10 tw-flex tw-flex-col tw-gap-4">

    {/* Header card */}
    <div className="tw-bg-white tw-rounded-2xl tw-border tw-border-slate-100 tw-shadow-sm tw-p-6">
      <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
        <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-violet-100 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
          <FiCpu size={18} className="tw-text-violet-600" />
        </div>
        <div>
          <h2 className="tw-text-base tw-font-bold tw-text-slate-900 tw-m-0">Background Job Monitor</h2>
          <p className="tw-text-xs tw-text-slate-400 tw-m-0 tw-mt-0.5">Sidekiq dashboard</p>
        </div>
      </div>

      <div className="tw-mb-5">
        <InfoRow icon={FiCheckCircle} label="Engine" value="Sidekiq 7" />
        <InfoRow icon={FiClock}       label="Queue backend" value="Redis" />
        <InfoRow icon={FiAlertCircle} label="Access" value="Admin only" />
      </div>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-py-2.5 tw-rounded-lg tw-bg-violet-600 hover:tw-bg-violet-700 tw-text-white tw-text-sm tw-font-semibold tw-transition-colors tw-no-underline"
      >
        <FiExternalLink size={15} />
        Open Sidekiq Dashboard
      </a>
    </div>

    {/* Note */}
    <div className="tw-flex tw-items-start tw-gap-2.5 tw-px-4 tw-py-3 tw-rounded-lg tw-bg-amber-50 tw-border tw-border-amber-100">
      <FiAlertCircle size={15} className="tw-text-amber-500 tw-flex-shrink-0 tw-mt-0.5" />
      <p className="tw-text-xs tw-text-amber-800 tw-m-0 tw-leading-snug">
        The dashboard opens in a new tab because embedding it in an iframe is blocked by browser security policy.
      </p>
    </div>

  </div>
);

export default BackgroundJobPage;
